<template>
  <div class="trailer-detail">
  <el-form ref="tform" class="egl-elm egl-detail" :model="trailer">
    <el-row :gutter="10">
      <el-col :span="3">
        <el-form-item :label="$locale('setting.cinema.trailer.type')" props="type">
          <el-select v-model="trailer.type">
            <el-option :value="1" :label="$locale('setting.cinema.trailer.option1')"/>
            <el-option :value="2" :label="$locale('setting.cinema.trailer.option2')"/>
          </el-select>
        </el-form-item>
      </el-col>
      <template v-if="trailer.type == 1">
        <el-col :span="13">
          <el-form-item :label="$locale('setting.cinema.trailer.link')" props="link">
            <el-input v-model="trailer.link" :placeholder="$locale('setting.cinema.trailer.link.p')"/>
          </el-form-item>
        </el-col>
      </template>
      <template v-else>
        <el-col :span="4">
          <el-form-item props="link">
            <UploadContainer
              :imageList="[trailer.link]"
              @onSuccess="({response}) => onSuccess(response)"
              @onDelete="removeUpload"
            ></UploadContainer>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item props="disylayTime">
            <span class="makeInline" slot="label">{{ $locale('setting.cinema.trailer.displaytime') }}</span>
            <el-input v-model="trailer.displayTime" placeholder="60"/>
          </el-form-item>
        </el-col>
      </template>
      <el-col :span="3">
        <el-form-item :label="$locale('global.order')">
          <el-input v-model="trailer.order" placeholder="1"/>
        </el-form-item>
      </el-col>
      <el-col :span="4" :style="{ 'display':'flex'}" >
        <div class="operation" v-if="count > 0 || total > 1"
        @click="dec(count)"> 
          <i class="el-icon-minus"></i>
        </div>
        <div class="operation" v-if="count == (total-1)" 
        @click="inc"> 
          <i class="el-icon-plus"></i>
        </div>
      </el-col>
    </el-row>
  </el-form>
  </div>
</template>

<style scoped>
.maxOut {
  width: 100%;
  margin-right:0px;
}
.makeInline {
  white-space: nowrap;
}
</style>

<script>
import "@/assets/style/trailer.less"
import UploadContainer from "@/components/common/UploadContainer";

export default {
  name: "TrailerForm",
  components: {
    UploadContainer,
  },
  props: {
    formObj : {
      type: Object,
      default: {},
    },
    total : {    
      type: Number,
      default : 0,
    },
    count: {
      type: Number,
      default: 0,
    }
  },

  data() {
    return {
      trailer: {
        type: this.formObj.type ? this.formObj.type : 1,
        link: this.formObj.link ? this.formObj.link : '',
        order: this.formObj.order ? this.formObj.order : 1,
        displayTime: this.formObj.displayTime ? this.formObj.displayTime : 60,
      },
      uploadUrl: "/api/system/uploadFile",
      tokenObj: {
        "Authorization": window.localStorage.getItem("token"),
      },
      uploading: false,

    }
  },
  
  methods : {
    getData() {
      return {
        type: this.trailer.type,
        link: this.trailer.link,
        order: this.trailer.order,
        displayTime: this.trailer.displayTime,
      }
    },

    inc() {
      this.$emit('add')
    },
    dec(idx) {
      this.$emit("del", idx)
    },

    onUploadingr() {
      this.uploading = true;
    },
    onSuccess(res) {
      this.uploading = false;
      this.trailer.link = res.data
    },
    onError() {
      this.uploading = false;
    },
    removeUpload() {
      // this.$refs.poster.clearFiles()
      this.trailer.link = ''
    }
  },

}
</script>
